module.exports = __webpack_public_path__ + "static/media/header__Logo.792d7cfe.svg";